import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
    open: false,
    loading: false,
    result: null,
    error: null,
    workOrder: null,
    workOrderStatuses: [],
    loadingWorkOrderStatuses: []
};

const route = "modules/workOrders/views/trackerTab/modals/changeStatus/redux/slice";

export const workOrderChangeStatusWorkOrder = createAsyncThunk("manage/changeStatus/changeStatusWorkOrder", async (payload, { rejectWithValue }) => {
    try {
        const response = await clientMutation(
            `mutation changeStatusWorkOrder ($id: Int!, $statusId: Int!, $note: String!) {
                result: changeStatusWorkOrder (id: $id, statusId: $statusId, note: $note)
            }`,
            payload,
            endpoints.GRAPHQL_GENERAL_V2
        );

        return { changeStatus: response?.result }

    } catch (exc) {
        ExceptionManager(exc, route, "changeStatusWorkOrder");
        return rejectWithValue(exc);
    }
}
);

export const workOrdersChangeStatusSearchStatuses = createAsyncThunk(
    "workOrders/workOrdersSettingsSearchWorkOrderTypes/searchWorkOrderStatuses",
    async ({ }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query ($conditions: [WorkOrderStatusSearchInput], $sort: [WorkOrderStatusSortInput], $limit: Int, $offset: Int) {
                        data: searchWorkOrderStatuses(
                            conditions: $conditions
                            sort: $sort
                            limit: $limit
                            offset: $offset
                        ) {
                            total
                            items {
                                id
                                name
                                color
                            }
                        }
                    }
                `,
                {
                    conditions: [],
                    sort: {
                        "field": "name",
                        "order": "ASC"
                    }
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data?.items || []

        } catch (exc) {
            ExceptionManager(exc, route, "searchWorkOrderTypes");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersChangeStatusRedux = createSlice({
    name: "workOrders/changeStatus",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalChangeStatusWorkOrder(state, action) {
            state.open = true;
            state.workOrder = action?.payload?.workOrder;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrderChangeStatusWorkOrder
        builder.addCase(workOrderChangeStatusWorkOrder.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderChangeStatusWorkOrder.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action.payload;
        });
        builder.addCase(workOrderChangeStatusWorkOrder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrdersChangeStatusSearchStatuses
        builder.addCase(workOrdersChangeStatusSearchStatuses.pending, (state) => {
            state.loadingWorkOrderStatuses = true;
        });
        builder.addCase(workOrdersChangeStatusSearchStatuses.fulfilled, (state, action) => {
            state.loadingWorkOrderStatuses = false;
            state.workOrderStatuses = action.payload;
        });
        builder.addCase(workOrdersChangeStatusSearchStatuses.rejected, (state, action) => {
            state.loadingWorkOrderStatuses = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersChangeStatusRedux;

// Extract and export each action creator by name
export const { reset, openModalChangeStatusWorkOrder } = actions;

// Export the reducer, either as a default or named export
export default reducer;